import {AlertError} from "../../../bootstrap/AlertError";
import {Formik} from "formik";
import {Col, Container, Form, Row} from "react-bootstrap";
import {DateTimeInputField} from "../../../bootstrap/DateTimeInputField";
import DecimalInputField from "../../../bootstrap/DecimalInputField";
import {FormattedMessage} from "react-intl";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {EnumSelectField} from "../../../bootstrap/EnumSelectField";
import {RevocationType} from "./RevocationType";
import {RestitutionType} from "./RestitutionType";
import {SingleUploadArea} from "../../../SingleUploadArea";
import {
    decideNonCompliance
} from "../../../../rest/nonCompliance";
import {DocumentType} from "../../../../models/DocumentType";
import {NonComplianceState} from "./NonComplianceState";


export function NonComplianceDecisionForm ({candidatureExternalId, nonCompliance, onCancel, onSubmitCallback,nonComplianceCauseToRegulationMap}) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const navigate = useNavigate();
    const [documents, setDocuments] = useState([]);

    async function onSubmit(values, setSubmitting, setErrors) {
        console.log("SUBMIT")
        setSubmitting(true);
        try {

            let {docNT: formDataNT, docSI: formDataSI, ...rest} = values;
            formDataSI.set('nonComplianceDecision', JSON.stringify(rest));
            formDataSI.set('file2', formDataNT.get('file'));
            formDataSI.set('fileName2', formDataNT.get('fileName'));
            formDataSI.set('documentType2', formDataNT.get('documentType'));
            formDataSI.set('size2', formDataNT.get('size'));
            formDataSI.set('extension2', formDataNT.get('extension'));

            console.log(formDataSI)

            await decideNonCompliance(candidatureExternalId, nonCompliance.externalId, formDataSI);
           onSubmitCallback?.()
            setSubmitted(true);
        } catch (error) {
            console.log(error);
            setErrors(error);
        }
        setSubmitting(false);
    }

    const validationSchema = yup.object().shape({
        state: yup
            .mixed()
            .oneOf([NonComplianceState.FINAL, NonComplianceState.CANCELED], <FormattedMessage id='errors.fieldRequiredText'/>)
            .required(<FormattedMessage id='errors.fieldRequiredText'/>),
        revocation:yup
            .mixed()
            .when('state', {
                is: (s) => (s === NonComplianceState.FINAL),
                then: (schema) => schema
                    .oneOf(RevocationType.values(), <FormattedMessage id='errors.fieldRequiredText'/>)
                    .required(<FormattedMessage id='errors.fieldRequiredText'/>),
            }).nullable(),
        restitution: yup
            .mixed()
            .when('state', {
                is: (s) => (s === NonComplianceState.FINAL),
                then: (schema) => schema
                    .oneOf(RestitutionType.values(), <FormattedMessage id='errors.fieldRequiredText'/>)
                    .required(<FormattedMessage id='errors.fieldRequiredText'/>),
            }).nullable(),

        restitutionValue: yup
            .number()
            .when('state', {
                is: (s) => (s === NonComplianceState.FINAL),
                then: (schema) => schema
                    .when('restitution', {
                        is: (r) => (r === RestitutionType.PARTIAL || r === RestitutionType.TOTAL),
                        then: (schema) => schema.typeError(<FormattedMessage id='errors.fieldRequiredText'/>)
                            .required(<FormattedMessage id='errors.fieldRequiredText'/>)
                            .min(0.01, <FormattedMessage id='candidature.payments.form.error.zeroPayment'/>),
                        otherwise: (schema) => schema.nullable()
                    }),
            }).nullable(),



    });

    const initialValues = {
        restitution: null,
        revocation:null,
        restitutionValue: null,
        causes: nonCompliance.causes,
        docSI: null,
        docNT: null,
        state: null,
    };



    function validation (values, props) {
        const errors = {};
        if (values.docSI === null) errors.docSI = <FormattedMessage id='need.documents'/>;
        if (values.docNT === null) errors.docNT = <FormattedMessage id='need.documents'/>;
        return errors;
    }

    function changeState(value,setFieldValue) {
        setFieldValue('state', value)
        if(NonComplianceState.FINAL !== value){
            setFieldValue('revocation', null)
            setFieldValue('restitution', null)
        }else{
            setFieldValue('revocation', nonCompliance.revocation)
            setFieldValue('restitution', nonCompliance.restitution)
        }

    }

    function changeCauses(target, cause,values,setFieldValue) {
        if(target.checked===true){
            values.causes.push(cause);
        }else{
            values.causes.splice(values.causes.indexOf(cause), 1)
        }
        setFieldValue('causes', values.causes);
    }

    return (
        <>
            <AlertError error={error} />
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                validateOnBlur={false}
                validate={validation}
                validateOnChange={false}
                onSubmit={(values, { setSubmitting, setErrors }) => {
                    onSubmit(values, setSubmitting, setErrors);

                }}>
                {({ values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue
                  }) => (
                    <Form onSubmit={handleSubmit}>
                        <AlertError error={errors} />
                        <Row>
                            <Col md={3}>
                                <EnumSelectField
                                    name='state'
                                    labelId='candidatureTabs.oversight.tabs.noncompliance.decision.question'
                                    options={[NonComplianceState.FINAL, NonComplianceState.CANCELED]}
                                    preffixDescriptionId='candidatureTabs.oversight.tabs.noncompliance.decisionState'
                                    nullOption={true}
                                    errorMessage={errors.state}
                                    value={values.state}
                                    handleChange={(e) => changeState(e.target.value,setFieldValue)}
                                />
                            </Col>
                            <Col md={3}>
                                <EnumSelectField
                                    name='revocation'
                                    labelId='candidatureTabs.oversight.tabs.noncompliance.form.leadsToRevogation'
                                    options={RevocationType.values()}
                                    preffixDescriptionId='candidatureTabs.oversight.tabs.noncompliance.form.revVal'
                                    nullOption={true}
                                    errorMessage={errors.revocation}
                                    value={values.revocation}
                                    handleChange={(e) => setFieldValue('revocation', e.target.value)}
                                    disabled={NonComplianceState.FINAL !==values.state}
                                />
                            </Col>
                            <Col md={3}>
                                <EnumSelectField
                                    name='restitution'
                                    labelId='candidatureTabs.oversight.tabs.noncompliance.form.aidRestitution'
                                    options={RestitutionType.values()}
                                    preffixDescriptionId='candidatureTabs.oversight.tabs.noncompliance.form.restVal'
                                    nullOption={true}
                                    errorMessage={errors.restitution}
                                    handleChange={(e) => setFieldValue('restitution', e.target.value)}
                                    value={values.restitution}
                                    disabled={NonComplianceState.FINAL !==values.state}
                                />
                            </Col>
                            <Col md={3}>

                                    <DecimalInputField
                                        name='restitutionValue'
                                        labelId='candidatureTabs.oversight.tabs.noncompliance.form.restitutionValue'
                                        suffixLabel='€'
                                        errorMessage={errors.restitutionValue}
                                        value={values.restitutionValue}
                                        handleChange={(e) => setFieldValue('restitutionValue', e.target.value)}
                                        disabled={![RevocationType.PARTIAL,RevocationType.TOTAL].includes(values?.restitution) }
                                    />
                            </Col>


                        </Row>
                        <Row className='mt-3'>
                            <Col>
                                <label>
                                    <FormattedMessage id='candidatureTabs.oversight.tabs.noncompliances' />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {Object.keys(nonComplianceCauseToRegulationMap).map( (cause) => (
                                    <><Form.Group key={cause} controlId={"nonComplianceCauses"+cause}>
                                        <Form.Check
                                            inline
                                            name={cause}
                                            type={'checkbox'}
                                            className={'d-flex align-items-center'}
                                            label={<FormattedMessage id={'candidatureTabs.oversight.tabs.noncompliance.cause.' + cause} />}
                                            checked={values.causes.includes(cause)}
                                            onChange={({target}) => changeCauses(target,cause,values,setFieldValue)

                                            }
                                        />
                                    </Form.Group>
                                </>
                                ))}
                                <Form.Control.Feedback type='invalid'>
                                    {errors.causes}
                                </Form.Control.Feedback>
                            </Col>
                        </Row>

                        <Row className='mt-3'>
                            <Col>
                                <label>
                                    <FormattedMessage id='documents.list' />
                                </label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <SingleUploadArea
                                    documents={documents}
                                    setDocuments={setDocuments}
                                    documentType={DocumentType.NON_COMP_DECISION}
                                    setError={setError}
                                    acceptExtensions='.pdf,.docx'
                                    processUploadCallback={formData => setFieldValue('docSI', formData)}
                                />
                                {"docSI" in errors &&
                                    <Form.Control.Feedback type='invalid'>{errors.docSI}</Form.Control.Feedback>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <SingleUploadArea
                                    documents={documents}
                                    setDocuments={setDocuments}
                                    documentType={DocumentType.NON_COMP_DECISION_NOTIFICATION}
                                    setError={setError}
                                    acceptExtensions='.pdf,.docx'
                                    processUploadCallback={formData => setFieldValue('docNT', formData)}
                                />
                                {"docNT" in errors &&
                                    <Form.Control.Feedback type='invalid'>{errors.docNT}</Form.Control.Feedback>
                                }
                            </Col>
                        </Row>

                        <Row className='form-actions'>
                            <Col className='justify-content-between d-flex'>
                                <button className='btn btn-outline-primary' type='button' onClick={() => onCancel?.()}>
                                    <FormattedMessage id='all.cancel' />
                                </button>
                                <button className='btn btn-primary' type='submit' >
                                    <FormattedMessage id='all.submitButtonText' />
                                </button>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Formik>
        </>
    );
}